export const getRecordingStopTitle = (teaching) => {
    if (!teaching || teaching.type === "discipline") {
        return "Закончить запись пройденных квантов";
    }
    return `Закончить записать пройденных квантов по курсу "${teaching.course.title}" для группы "${teaching.group.title}"`;
};
